import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import Awards from '../Awards';
import Publications from '../Publications';
import ProfessionalMembers from '../ProfessionalMembers';
import { PublicationRecognitionItem, IBackgroundInfo, RecognitionItem } from 'types/newUniprofile';

interface Props {
    awardRecognitionList?: RecognitionItem[];
    associationRecognitionList?: RecognitionItem[];
    publicationRecognitionList?: PublicationRecognitionItem[];
    isEditing?: boolean;
    updateFn: (data: Partial<IBackgroundInfo>) => Promise<void>;
}

const Recognition = forwardRef((props: Props, ref) => {
    const { awardRecognitionList, associationRecognitionList, publicationRecognitionList, isEditing, updateFn } = props;
    const professionalRef = useRef<{ getValues: () => Promise<RecognitionItem[]> }>(null);
    const awardsRef = useRef<{ getValues: () => Promise<RecognitionItem[]> }>(null);
    const publicationsRef = useRef<{ getValues: () => Promise<PublicationRecognitionItem[]> }>(null);

    const onSubmit = async () => {
        try {
            const [professionalValues, awardsValues, publicationsValues] = await Promise.all([
                professionalRef.current?.getValues(),
                awardsRef.current?.getValues(),
                publicationsRef.current?.getValues(),
            ]);
            await updateFn({
                associationRecognitionList: professionalValues,
                awardRecognitionList: awardsValues,
                publicationRecognitionList: publicationsValues,
            });
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    useImperativeHandle(ref, () => ({
        onSubmit,
    }));

    return (
        <>
            <ProfessionalMembers isEditing={isEditing} initValue={associationRecognitionList} ref={professionalRef} />
            <Awards isEditing={isEditing} initValue={awardRecognitionList} ref={awardsRef} />
            <Publications isEditing={isEditing} initValue={publicationRecognitionList} ref={publicationsRef} />
        </>
    );
});

export default Recognition;
